// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--xnUte {\n  background: var(--main-bg-color);\n  min-height: 100vh;\n  display: flex;\n}\n.s-module__wrap--xnUte .s-module__mr20--iM6mR {\n  margin-right: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/operation/HelloKlarityReviews/components/Complaints/s.module.less"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,iBAAA;EACA,aAAA;AACF;AAJA;EAMI,kBAAA;AACJ","sourcesContent":[".wrap {\n  background: var(--main-bg-color);\n  min-height: 100vh;\n  display: flex;\n\n  .mr20 {\n    margin-right: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--xnUte",
	"mr20": "s-module__mr20--iM6mR"
};
export default ___CSS_LOADER_EXPORT___;
